<ion-header [translucent]="true">
	<ion-toolbar class="payment-header">
		<div class="ion-text-wrap">
			<ion-title mode="md">{{ 'tipSelection.title' | translate }}</ion-title>
		</div>
		<ion-buttons class="ion-display-none" slot="end">
			<ion-button (click)="close()" fill="clear">
				<ion-icon name="close"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-col class="payment-content">
	<ion-col class="ion-align-content-center ion-padding-bottom">
		<ion-row class="ion-justify-content-center">
			<div class="subtitle">{{ 'tipSelection.question' | translate }}</div>
		</ion-row>
		<ion-row class="ion-justify-content-center ion-margin-bottom">
			<h1>{{ totalTipText }}</h1>
		</ion-row>
		<div class="ion-padding"></div>
		<div class="tip-section ion-margin-vertical">
			<app-tip-selector
				(tipChange)="selectTip($event)"
				[itemCount]="itemCount"
				[selectedTip]="selectedTip"
				[totalPrice]="totalPrice"
			></app-tip-selector>
		</div>
		<div class="ion-padding"></div>
		<div class="ion-padding"></div>
	</ion-col>
</ion-col>

<ion-footer class="payment-footer">
	<ion-button (click)="confirm()" [disabled]="!selectionHappened" color="primary" expand="block"
		>{{ 'common.continue' | translate }}
	</ion-button>
</ion-footer>
